<template>
  <v-container class="no-margins">
    <template v-for="(d, name, index) in departments">
      <v-card :key="index" flat class="mb-6">
        <h4>{{ name }}</h4>
        <v-expand-transition v-if="d.length > 0">
          <slot name="employee-list" v-bind:employeeList="d">
          <v-list>
            <v-list-item-group>
              <template v-for="(emp, index) in d">
                <v-divider :key="`divider-${index}`" v-if="index"></v-divider>
                <v-list-item
                  :key="`d-${index}`"
                  @click="empClick(emp)"
                  :disabled="getIsDisabled(emp)"
                  :class="type == 'instructor' ? 'v-list-item--three-line' : ''"
                >
                  <v-list-item-avatar>
                    <v-icon v-if="type == 'apprentice'">$sl-apprentice</v-icon>
                    <v-icon v-else>{{ getRoleAvatarDepartment(emp, emp.depId) }}</v-icon>
                  </v-list-item-avatar>

                  <v-list-item-content>
                    <v-list-item-title
                      >{{ displayName(emp)}}
                      <v-icon size="8" class="mr-1" v-if="isMaxApprenticesForInstructor(emp)"
                        >$sl-error</v-icon
                      >
                      <v-icon size="8" v-if="needToReadInstructor(emp.employed) && $route.name=='CompanyInstructors'"
                        >$sl-triangle</v-icon
                      >
                    </v-list-item-title>
                    <v-list-item-subtitle
                      v-if="type == 'instructor'"
                      v-text="getNoOfApprentices(emp) + (getDescProf(emp) || '').toLowerCase()"
                    ></v-list-item-subtitle>
                    <v-list-item-subtitle
                      v-else-if="!['apprentice'].includes(type)"
                      v-text="getRolesText(emp, emp.depId)"
                    ></v-list-item-subtitle>
                    <v-list-item-subtitle
                      v-else
                      v-text="getApprDesc(emp.type, emp.toDate)"
                    ></v-list-item-subtitle>
                  </v-list-item-content>

                  <v-list-item-action>
                    <v-icon class="icon-far-right">{{ nextIcon }}</v-icon>
                  </v-list-item-action>
                </v-list-item>
              </template>
            </v-list-item-group>
          </v-list>
          </slot>
        </v-expand-transition>
      </v-card>
    </template>
  </v-container>
</template>

<script>
import API from "@/services/api.js";
import { mapGetters } from "vuex";
import find from "lodash/find";
import uniqBy from "lodash/uniqBy";
import groupBy from "lodash/groupBy";
import assign from "lodash/assign";
import ActionButton from "@/components/Common/ActionButton";
import { CompanyRoles, InstructorAbilities } from "@/components/mixins";

const SugarDate = require("sugar/date");

// @group Company
// CompanyEmployeeList component
export default {
  name: "CompanyEmployeeListDepartments",

  mixins: [CompanyRoles, InstructorAbilities],

  props: {
    emp: Array,
    type: {
      // `'String'`
      type: String,
      // 'all', 'apprentice', 'employed', 'instructor', 'companyEducationResponsible', 'distanceEducationAdministrator', 'administrator'
      default: "all",
    },
    nextIcon: {
      type: String,
      // `'String'`
      default: "$sl-arrow-right",
      // The default value is icon: `$sl-arrow-right`
    },
    //Next list
    nextTo: {
      // `'String'`
      type: String,
      // The default value is icon: `CompanyEmployee`
      default: "CompanyEmployee",
    },
  },

  watch: {
    emp: {
      handler: function () {
        this.init();
      },
    },
  },
  data() {
    return {
      employees: [],
      departments: [],
      noDepartment: [],
    };
  },

  components: {
    ActionButton,
  },

  created() {
    this.init();
  },
  computed: {
    ...mapGetters("currentuser", ["currentUser", "isAdministrator"]),
  },
  methods: {
    init() { 
      this.employees = this.emp;
      let empDep = [];
      let noDep = [];
      let emp = this.currentUser.employments.find(
        (x) => x.companyId == this.$route.params.id
      );
      if (this.type == "apprentice") {
        this.employees.forEach((em) => {
          if (em.workplaces.length == 0) {
            noDep.push({
              id: em.id,
              type: em.type,
              apprentice: em.apprentice,
              education: em.education,
              instructors: em.instructors,
              depName: this.$t("company.missing-department"),
              toDate: em.toDate
            });
          }

          em.workplaces.forEach((wp) => {
            if(!wp.workplaceaddress.departmentWorkplaces.length){
              noDep.push({
                id: em.id,
                type: em.type,
                apprentice: em.apprentice,
                education: em.education,
                instructors: em.instructors,
                depName: this.$t("company.missing-department"),
                toDate: em.toDate
              });
            }

            wp.workplaceaddress.departmentWorkplaces.forEach((dep) => {
              if (this.isAdministrator == true || this.hasDepartmentId(emp, dep.departmentId, false) == true) {
                empDep.push({
                  id: em.id,
                  uniqId: em.id + ":" + dep.departmentId,
                  apprentice: em.apprentice,
                  education: em.education,
                  instructors: em.instructors,
                  depName: dep.department.name,
                  type: em.type,
                  toDate: em.toDate
                });
              }
            });
          });
        });

        empDep = uniqBy(empDep, "uniqId");
        noDep = uniqBy(noDep, "apprentice.id");

        this.noDepartment = groupBy(noDep, function (o) {
          return o.depName;
        });
        this.departments = groupBy(empDep, function (o) {
          return o.depName;
        });

        this.departments = assign(this.departments, this.noDepartment);
      } else {
        this.employees.forEach((em) => {
          if (em.departmentEmployments.length == 0) {
            noDep.push({
              id: em.id,
              depId: -1,
              apprentices: em.apprentices,
              employed: em.employed,
              departmentEmployments: em.departmentEmployments,
              depName: this.$t("company.missing-department"),
              roles: "",
              isAdministrator: em.isAdministrator,
              isDepartmentAdministrator: false,
              isCompanyEducationResponsible: false,
              isDistanceEducationAdministrator: false,
              isInstructor: false,
              toDate: em.toDate
            });
          }
          em.departmentEmployments.forEach((dep) => {
            let addObject = true;
//console.log("type::", this.getCurrentUserDepartmentsIds(this.$route.params.id, this.isAdministrator))
            if (this.type == "companyEducationResponsible") {
              addObject = dep.isDepartmentEducationResponsible;
              if (addObject == true) {
                let findDep = -1;
                if (this.isAdministrator != true) {
                  if (
                    this.getCurrentUserDepartmentsIds(
                      this.$route.params.id,
                      this.isAdministrator
                    ).length > 0
                  ) {
                    findDep = this.getCurrentUserDepartmentsIds(
                      this.$route.params.id,
                      this.isAdministrator
                    ).find((x) => x == dep.department.id);
                  }

                  if (!findDep > 0) {
                    addObject = false;
                  }
                }
              }
            } else if (this.type == "instructor") {
              addObject = dep.isDepartmentInstructor;

              if (addObject == true) {
                let findDep = -1;
                if (
                  this.getCurrentUserDepartmentsIds(
                    this.$route.params.id,
                    this.isAdministrator, false
                  ).length > 0
                ) {
                  findDep = this.getCurrentUserDepartmentsIds(
                    this.$route.params.id,
                    this.isAdministrator, false
                  ).find((x) => x == dep.department.id);
                }

                if (!findDep > 0) {
                  addObject = false;
                }
              }
            } else if (this.type == "employed" && this.isAdministrator != true) {
              addObject = true;
              //console.log("employed::", this.getCurrentUserDepartmentsIds(this.$route.params.id))
              if (addObject == true) {
                let findDep = -1;
                if (
                  this.getCurrentUserDepartmentsIds(this.$route.params.id, this.isAdministrator, false).length > 0
                ) {
                  findDep = this.getCurrentUserDepartmentsIds(
                    this.$route.params.id,
                    this.isAdministrator, false
                  ).find((x) => x == dep.department.id);
                }

                if (!(findDep > 0)) {
                  addObject = false;
                }
              }
            }

            if (addObject == true) {
              empDep.push({
                id: em.id,
                depId: dep.id,
                employed: em.employed,
                profession: em.profession,
                apprentices: em.apprentices,
                departmentEmployments: em.departmentEmployments,
                depName: dep.department.name,
                roles: dep.roles,
                isDepartmentAdministrator: dep.isDepartmentAdministrator,
                isAdministrator: em.isAdministrator,
                isCompanyEducationResponsible: dep.isDepartmentEducationResponsible,
                isDistanceEducationAdministrator:
                  dep.isDepartmentDistanceEducationAdministrator,
                isInstructor: dep.isDepartmentInstructor,
              });
            }
          });
        });
        this.noDepartment = groupBy(noDep, function (o) {
          return o.depName;
        });
        this.departments = groupBy(empDep, function (o) {
          return o.depName;
        });
        this.departments = assign(this.departments, this.noDepartment);
      }
    },
    getApprDesc(type, toDate) {
      let ret,
        tdate = "";

      if (toDate && toDate != "") {
        tdate =
          ", " +
          this.$t("company.plan") +
          ". " +
          SugarDate.Date(toDate).format("%Y-%m-%d");
      }
      if (type == "QualificationTime")
        ret = this.$t("labels.apprentice") + " (KT)" + tdate;
      else ret = this.$t("labels.apprentice") + " (GU)" + tdate;
      return ret;
    },
    isMaxApprenticesForInstructor(emp) {
      if (this.type == "instructor") {
        if (
          emp.apprentices &&
          emp.profession &&
          emp.profession.maxApprenticesForInstructor &&
          emp.profession.maxApprenticesForInstructor <= emp.apprentices.length
        ) {
          return true;
        }
      }
      return false;
    },
    getNoOfApprentices(emp) {
      if (emp.apprentices)
        return this.$tc("company.appr", emp.apprentices.length) + " - ";
    },
    getDescProf(emp) {
      let ret = [];
      if (
        emp.employed &&
        emp.employed.instructorExemptions &&
        emp.employed.instructorExemptions.length > 0
      ) {
        emp.employed.instructorExemptions.forEach((element) => {
          if (element.profession && element.profession.name)
            ret.push(element.profession.name);
        });
      }
      if (
        emp.employed &&
        emp.employed.tradeCertificates &&
        emp.employed.tradeCertificates.length > 0
      ) {
        emp.employed.tradeCertificates.forEach((element) => {
          if (element.profession && element.profession.name)
            ret.push(element.profession.name);
        });
      }
      return ret.join(", ");
    },
    getDescText(emp) {
      if (this.getDepartments(emp) == "")
        return this.getShortRoleDescription(
          emp,
          this.hasDepartments(this.$route.params.id)
        );
      return (
        this.getShortRoleDescription(emp, this.hasDepartments(this.$route.params.id)) +
        " (" +
        this.getDepartments(emp) +
        ")"
      );
    },
    getRolesText(emp, id) {
      if (this.getDepartments(emp) == "")
        return this.getShortRoleDescription(
          emp,
          this.hasDepartments(this.$route.params.id)
        );
      return (
        this.getShortRoleDescriptionDepartment(emp, id) //+ " (" + this.getDepartments(emp) + ")"
      );
    },
    /**
     * @vuese
     * Used to fetch workplace
     * @arg The arguments are  integers value representing company id and workplace id
     */
    getIsDisabled(e) {
      if (e && e.employed && e.employed.isActive == false) {
        return true;
      }
      return false;
    },

    /**
     * @vuese
     * Used to display full name
     */
    displayName(emp) {
      if (emp.employed) {
        if (!emp.employed.firstName && emp.employed.email) {
          return emp.employed.email;
        } else {
          return `${emp.employed.firstName} ${emp.employed.lastName}`;
        }
      }
      if (emp.apprentice) return `${emp.apprentice.firstName} ${emp.apprentice.lastName}`;
      return "";
    },

    /**
     * @vuese
     * Used to redirect once the the element of the list is clicked
     * @arg The argument is an string that used as route name
     */
    empClick(emp) {
      if (this.type === "myApprentices") {
        this.$nextTick(() => {
          this.$router.push({
            name: "CompanyApprentice",
            params: { id: emp.company.id, employee_id: emp.id, isApprentice: true },
          });
        });
      } else if (this.type === "all") {
        // Could be both apprentice and employed type
        if (emp.apprentice) {
          this.$nextTick(() => {
            this.$router.push({
              name: "CompanyApprentice",
              params: {
                id: this.$route.params.id,
                employee_id: emp.id,
                isApprentice: true,
              },
            });
          });
        } else {
          this.$nextTick(() => {
            this.$router.push({
              name: "CompanyEmployee",
              params: {
                id: this.$route.params.id,
                employee_id: emp.id,
                isApprentice: false,
              },
            });
          });
        }
        return;
      } else {
        this.$nextTick(() => {
          this.$router.push({
            name: this.nextTo,
            params: {
              id: this.$route.params.id,
              employee_id: emp.id,
              isApprentice: emp.apprentice ? true : false,
            },
          });
        });
      }
    },
    /**
     * @vuese
     * Used to fetch the list based on the type that is required
     * @arg The argument can be apprentice , employes list
     */
  },
};
</script>
